// The product dialog's words in English, by key: its tabs (the built-in ones
// and those the store product extensions bring — a tab's label is its English)
// and the tab rail's filter. The fallback of the CMS TextBundle
// "store_product_editor" (./useProductEditorTexts.js), and what it is seeded
// from; the bundle is aldooCore, so it travels with the framework's updates.
export default {
  details: "Details",
  information: "Information",
  pricing: "Pricing",
  availability: "Availability",
  licensing: "Licensing",
  metadata: "Metadata",
  bundle_configuration: "Bundle Configuration",
  store_page: "Store Page",
  authors: "Authors",
  images: "Images",
  trailer: "Trailer",
  categories: "Categories",
  languages: "Languages",
  organization: "Organization",
  // not `content`: a translation's `content` field is read as the whole translation
  content_tab: "Content",
  discounts: "Discounts",
  shipping: "Shipping",
  referral: "Referral",
  deliverables: "Deliverables",
  license_keys: "License Keys",
  platforms: "Platforms",
  user_feedback: "User Feedback",
  product_review: "Product Review",
  find_a_tab: "Find a tab...",
  sections: "Sections",
  field_purchase_type: "Purchase Type",
  field_purchase_type_hint: "The type of product being configured",
  field_product_id: "Product ID",
  field_product_id_hint: "Unique identifier for the product (e.g., pt-module-princess)",
  field_product_name: "Product Name",
  field_product_name_hint: "The display name of the product on the store (defaults to English)",
  field_thumbnail: "Thumbnail",
  field_thumbnail_hint: "Product thumbnail image",
  field_description: "Description",
  field_description_hint: "Detailed product description (defaults to English)",
  field_category: "Category",
  field_category_hint: "The category under which the product appears in the store",
  field_enabled: "Enabled",
  field_enabled_hint: "Whether the product is offered to the end-user — off takes it out of the store and refuses new purchases",
  field_availability_check: "How to check product availability?",
  field_availability_check_hint: "Select the resolvers to determine product availability",
  field_amount: "Amount",
  field_amount_hint: "Value amount (applicable for currency type products)",
  field_consumable: "Consumable",
  field_consumable_hint: "Whether the product is consumed immediately instead of being added to inventory",
  field_created_date: "Created Date",
  field_created_date_hint: "Date when the product was created",
  field_last_updated: "Last Updated",
  field_last_updated_hint: "Date when the product was last modified",
  field_price_configuration: "Price Configuration",
  field_price_configuration_hint: "Associated price configuration for the product",
  subscription_group: "Subscription Group",
  field_subscription_group_hint: "Controls subscription replacement — 'single' groups cancel the existing sub when a new one is purchased",
  field_license_model: "License Model",
  field_license_model_hint: "Optional license model that will be generated when user purchases this product",
  field_supported_platforms: "Supported Platforms",
  field_supported_platforms_hint: "Device platforms that can activate licenses generated from this product",
  field_license_seats: "License Seats",
  field_license_seats_hint: "Specify custom seats that will overwrite the LicenseModel setting. This allows you to create custom seats when purchasing this product",
  field_metadata_hint: "Additional metadata for app-specific business logic",
  field_bundle_items: "Bundle Items",
  field_bundle_items_hint: "Products included in this bundle",
  see_subscription_groups: "See subscription groups",
  none: "None",
  loading_groups: "Loading groups…",
  select_subscription_group: "Select subscription group…",
  product_id_copied: "Product ID copied to clipboard",
  not_available_short: "N/A",
  use_license_model_seats: "Use License Model Seats",
  custom: "Custom",
  select_seat_configuration: "Select seat configuration...",
  number_of_seats: "Number of seats:",
  select_supported_platforms: "Select supported platforms...",
  all_platforms: "All Platforms",
  save_product_first_to_check: "Please save the product first to check availability",
  failed_to_check_availability: "Failed to check availability",
  error_checking_availability: "Error checking availability",
  unsaved_changes: "Unsaved Changes",
  save_before_checking_availability: "You need to save the product before checking for availability.",
  save_now: "Save Now",
  cancel: "Cancel",
  saving_product: "Saving product...",
  product_saved_successfully: "Product saved successfully",
  save_function_not_available: "Save function not available. Please save manually and try again.",
  failed_to_save_product_validation: "Failed to save product. Please check for validation errors.",
  select_availability_resolver: "Select availability resolver...",
  check_availability: "Check Availability",
  checking: "Checking...",
  product_is_available: "Product is available",
  out_of_stock: "Out of stock",
  price_created_link_failed: "Price created but failed to link to product: %s",
  price_created_and_linked: "Price created and linked successfully",
  price_updated_successfully: "Price updated successfully",
  failed_to_save_price: "Failed to save price",
  failed_to_load_price_data: "Failed to load price data",
  add_regular_price_hint: "Please add a regular price with amount, currency, and type",
  product_updated_successfully: "Product updated successfully",
  product_created_successfully: "Product created successfully",
  create_store_product: "Create Store Product",
  create_store_product_message: "Once a store product is created its Product ID can't be changed. You can always create a new one if needed.",
  proceed: "Proceed",
  go_back: "Go Back",
  failed_to_create_default_price: "Failed to create default price: %s",
  store_product: "Store Product",
  delete_product: "Delete product",
  delete_s_it_leaves_the_store_and_the_listings_at: "Delete %s? It leaves the store and the listings at once. You can bring it back from Products → Restore, or delete it for good there.",
  delete: "Delete",
  s_deleted: "%s deleted",
  title: "Title",
  content_type: "Content Type",
  select_content_type: "Select content type",
  select: "Select",
  duration: "Duration",
  minutes: "minutes",
  age_rating: "Age Rating",
  suitable_for_over: "Suitable for over",
  presentation_order: "Presentation Order",
  higher_numbers_appear_first_on_author_pages_use: "Higher numbers appear first on author pages. Use to prioritize featured books (default: 0)",
  fields: "Fields",
  copy_the_product_id: "Copy the product id",
  delete_this_product: "Delete this product",
  it_leaves_the_store_at_once_and_waits_in_product: "It leaves the store at once and waits in Products → Restore, where it can be brought back or deleted for good.",
  select_content_type_2: "Select Content Type",
  search_by_name: "Search by name",
  untitled: "[Untitled]",
  no_content_types: "No content types",
  rows_per_page: "Rows per page",
  s_s_of_s: "%s–%s of %s",
  s_of_s: "%s of %s",
  could_not_change_the_review_state: "Could not change the review state",
  reject_this_product: "Reject this product?",
  s_goes_back_to_its_organization_and_leaves_the_s: "%s goes back to its organization and leaves the store: its page answers that it is not available, and it cannot be bought. Sending it for review again is up to them.",
  s_goes_back_to_its_organization_sending_it_for_r: "%s goes back to its organization. Sending it for review again is up to them.",
  reject: "Reject",
  a_message_to_the_vendor_with_the_decision_option: "A message to the vendor with the decision (optional)",
  anything_the_reviewer_should_know_optional: "Anything the reviewer should know (optional)",
  your_company_details_are_incomplete_so_this_prod: "Your company details are incomplete, so this product cannot be sent for review yet.",
  missing_s: "Missing: %s.",
  open_the_company_checklist: "Open the company checklist",
  complete_your_company_details_first: "Complete your company details first",
  sending: "Sending…",
  send_for_review: "Send for Review",
  withdraw: "Withdraw",
  decision: "Decision",
  approve: "Approve",
  takes_effect_at_once_and_the_vendor_is_told_the: "Takes effect at once, and the vendor is told; the message above goes with it.",
  the_s_is_not_the_correct_size: "The %s is not the correct size",
  the_s_aspect_ratio_must_be_s: "The %s aspect ratio must be %s",
  failed_to_upload_screenshot: "Failed to upload screenshot",
  failed_to_upload_the_hover_image: "Failed to upload the hover image",
  product_page: "Product Page",
  screenshots: "Screenshots",
  hover_image: "Hover Image",
  square: "square",
  correct: "correct",
  any_size_its_own_aspect: "any size, its own aspect",
  no_picture_in_s_yet_showing_the_s_one: "No picture in %s yet: showing the %s one",
  changes_in_review_n: "Changes in review: %s",
  your_changes_have_been_sent_for_review: "Your changes have been sent for review",
  waiting_for_a_reviewer_the_product_stays_on_sale: "Waiting for a reviewer: the product stays on sale as it is until they are approved",
  your_changes_need_attention: "Your changes need attention",
  your_changes_are_in_review: "Your changes are in review",
  a_reviewer_looked_at_your_changes_edit_what_is_m: "A reviewer looked at your changes. Edit what is marked below, then send the changes again. The product stays on sale as it is until they are approved.",
  a_reviewer_will_look_at_your_changes_the_product: "A reviewer will look at your changes. The product stays on sale as it is until they are approved; you may keep editing meanwhile.",
  discard_your_changes: "Discard your changes?",
  the_changes_waiting_for_review_and_the_pictures: "The changes waiting for review and the pictures uploaded for them are deleted; the product stays as it is on sale.",
  discard: "Discard",
  your_changes_were_discarded: "Your changes were discarded",
  edited: "edited",
  a_note_for_the_reviewer_optional: "A note for the reviewer (optional)",
  discard_changes: "Discard changes",
  send_changes_again: "Send changes again",
  what_the_reviewer_asks_you_to_change: "What the reviewer asks you to change",
  make_the_changes_then_send_it_for_review_again: "Make the changes, then send it for review again.",
  pictures: "Pictures",
  product_type: "Product type",
  delivery: "Delivery",
  other: "Other",
  review_required: "Review Required",
  a_reviewer_asks_for_changes_make_them_then_send: "A reviewer asks for changes. Make them, then send it for review again.",
  change_each_marked_item_then_it_can_be_sent_for: "Change each marked item; then it can be sent for review again.",
  change_what_the_reviewer_marked_first: "Change what the reviewer marked first",
  upload_for_s: "Upload for %s",
  remove: "Remove",
  add_screenshot: "Add Screenshot",
  drop_paste_or_pick_an_image_crop_it_and_it_is_ad: "Drop, paste or pick an image, crop it and it is added to the screenshots",
  no_screenshots_uploaded_yet: "No screenshots uploaded yet",
  view_full_size: "View full size",
  screenshot_s: "Screenshot %s",
  the_hover_image_is_what_a_product_card_or_thumbn: "The hover image is what a product card or thumbnail turns to when the shopper's pointer rests on it, in the shop's lists, rows and search results. A second view of the product (the back of a shirt, the outfit worn) works best.",
  random_from_screenshots: "Random from screenshots",
  one_of_the_screenshots_picked_anew_each_time_the: "One of the screenshots, picked anew each time the list is read. The default.",
  specific_screenshot: "Specific screenshot",
  always_the_one_screenshot_chosen_below: "Always the one screenshot chosen below.",
  image_for_the_hover_only: "Image for the hover only",
  a_picture_uploaded_for_this_shown_nowhere_else: "A picture uploaded for this, shown nowhere else.",
  pick_the_screenshot: "Pick the screenshot",
  hover_image_2: "Hover image",
  product_categories: "Product Categories",
  categories_filed_by_the_import: "Filed by the import. A change here is kept: the import no longer files this product.",
  categories_set_by_hand: "Set by hand: the import leaves these categories as they are.",
  categories_back_to_import: "Back to the import's categories",
  categories_back_to_import_done: "Handed back: the next import run (or Apply rules) files it again.",
  add_categories_and_reorder_them_the_first_catego: "Add categories and reorder them. The first category is used for the breadcrumb navigation on the product page.",
  add_category: "Add Category",
  selected_categories_drag_to_reorder: "Selected Categories (drag to reorder):",
  primary_used_in_breadcrumb: "(Primary - used in breadcrumb)",
  the_product_s_place_in_this_category_s_order_low: "The product's place in this category's order: lower first (0 is the first place); empty comes after the positioned ones",
  position: "Position",
  author: "Author",
  author_display_name_optional: "Author Display Name (optional)",
  translator: "Translator",
  illustrator: "Illustrator",
  narrator: "Narrator",
  save_the_product_first_its_feedback_comes_from_b: "Save the product first: its feedback comes from buyers.",
  what_buyers_said_about_this_product_their_rating: "What buyers said about this product: their ratings, their written reviews and why they sent it back.",
  book_trailer_youtube_url: "Book Trailer - YouTube URL",
  book_trailer: "Book trailer",
  no_trailer: "No trailer",
  button_code_copied: "Button code copied",
  external_purchase_code: "External Purchase Code",
  copy_code: "Copy Code",
  use_the_content_type_s_defaults: "Use the content type's defaults?",
  the_fields_chosen_for_this_product_are_replaced: "The fields chosen for this product are replaced by the %s defaults (%s field), in their order. What this product shows now is lost.",
  content_type_2: "content type",
  the_fields_chosen_for_this_product_are_replace_2: "The fields chosen for this product are replaced by the %s defaults (%s fields), in their order. What this product shows now is lost.",
  use_defaults: "Use defaults",
  product_fields: "Product Fields",
  use_s_defaults: "Use %s Defaults",
  which_fields_this_product_s_page_shows_and_in_wh: "Which fields this product's page shows, and in which order — drag to reorder. A new product starts from its content type's defaults; what is chosen here is this product's own.",
  only_the_people_who_edit_it_can_see_this_product: "Only the people who edit it can see this product. Send it for review when it is ready.",
  waiting_for_a_platform_admin_to_approve_or_rejec: "Waiting for a platform admin to approve or reject it.",
  approved_whether_the_store_offers_it_is_the_enab: "Approved. Whether the store offers it is the Enabled switch on Availability.",
  rejected_send_it_for_review_again_once_the_notes: "Rejected. Send it for review again once the notes are addressed.",
  it_is_already_waiting_for_review: "It is already waiting for review.",
  it_is_published_already: "It is published already.",
  it_is_not_waiting_for_review: "It is not waiting for review.",
  that_is_not_yours_to_do: "That is not yours to do.",
  sent_for_review: "Sent for review",
  taken_back_from_review: "Taken back from review",
  approved: "Approved",
  rejected: "Rejected",
  original: "Original",
  square_thumb: "Square Thumb",
  thumb: "Thumb",
  cover: "Cover",
  contact_email: "Contact email",
  email_for_orders: "Email for orders",
  phone: "Phone",
  payout_details_company_and_bank_account: "Payout details (company and bank account)",
  at_least_one_shipping_provider: "At least one shipping provider",
  return_address_for_physical_goods: "Return address for physical goods",
  return_policy_link: "Return policy link",
  return_policy: "Return policy",
  sign_the_payout_contract: "Sign the payout contract",
  return_period: "Return period",
  low_stock_threshold: "Low stock threshold",
  available_for_purchase: "Available for purchase",
  published_by: "Published by",
  publish_date: "Publish date",
  deliverable_types: "Deliverable Types",
  deliverable_count: "Deliverable Count",
  worldwide: "worldwide",
  shipping_information: "Shipping Information",
  set_shipping_details_for_physical_products: "Set shipping details for physical products",
  weight: "Weight",
  grams: "grams",
  the_products_weight_field_information_fields_the: "The product's \"weight\" field (Information → Fields): the shipping cost is computed from it.",
  dimensions: "Dimensions",
  the_products_dimensions_field_as_the_store_page: "The product's \"dimensions\" field, as the store page lists it.",
  packaging_weight: "Packaging Weight",
  free_shipping: "Free Shipping",
  ships_to: "Ships to",
  company_default_x_override_here_for_this_specifi: "Company default: %s. Override here for this specific product.",
  countries: "Countries",
  until_one_is_picked_the_product_ships_worldwide: "Until one is picked, the product ships worldwide.",
  delivery_days: "Delivery Days",
  company_default_x_days_override_here_for_this_sp: "Company default: %s days. Override here for this specific product.",
  return_days: "Return Days",
  company_default_x_days_leave_empty_to_use_it_at: "Company default: %s days. Leave empty to use it; at least 14 by law.",
  company_default: "Company default",
  worldwide_2: "Worldwide",
  selected_countries_only: "Selected countries only",
  column_x: "Column %s",
  import_keys: "Import Keys",
  free_x: "Free: %s",
  reserved_x: "Reserved: %s",
  taken_x: "Taken: %s",
  total_x: "Total: %s",
  refresh: "Refresh",
  search_keys: "Search keys...",
  all: "All",
  free: "Free",
  reserved: "Reserved",
  taken: "Taken",
  no_keys_found: "No keys found.",
  prev: "Prev",
  page_x_of_x: "Page %s of %s",
  x_keys: "%s keys",
  next: "Next",
  import_license_keys: "Import License Keys",
  paste_keys_below_one_per_line_or_a_csv_duplicate: "Paste keys below — one per line, or a CSV. Duplicate keys are skipped automatically.",
  select_file: "Select file",
  platform: "Platform",
  csv_column_that_holds_the_keys: "CSV column that holds the keys",
  imported_x_keys_x_duplicates_skipped_free_keys_n: "Imported %s keys (%s duplicates skipped). Free keys now: %s",
  importing: "Importing…",
  import: "Import",
  delete_license_key: "Delete License Key",
  are_you_sure_you_want_to_delete_this_key_this_ac: "Are you sure you want to delete this key? This action cannot be undone.",
  deleting: "Deleting…",
  pre_sale: "Pre-sale",
  pre_sale_sells_a_product_before_it_is_out_its_ca: "Pre-sale sells a product before it is out. Its card and page carry a Pre-sale badge, and the cart, the delivery step and the order tell the buyer it is delivered by up to 3 days after the release date. It ends by itself on the release date: from that day the product sells as any other. An imported product follows its source (a book the publisher lists as coming); a change made here stays until the source's availability changes.",
  sell_it_before_it_is_out_it_ends_by_itself_on_th: "Sell it before it is out; it ends by itself on the release date.",
  on: "On",
  off: "Off",
  release_date: "Release date",
  on_pre_sale_until_x_delivered_by_x: "On pre-sale until %s; delivered by %s",
  pre_sale_ended_on_x_the_product_sells_as_any_oth: "Pre-sale ended on %s: the product sells as any other",
  pre_sale_can_be_turned_on_with_a_release_date_af: "Pre-sale can be turned on with a release date after today",
  company_setting: "Company setting",
  limits_are_off_for_the_company: "Limits are off for the company",
  company_setting_x: "Company setting: %s",
  company_setting_no_limit: "Company setting: no limit",
  maximum_items_per_product: "Maximum items per product",
  limits_how_many_items_a_customer_can_purchase_of: "Limits how many items a customer can purchase of this product.",
  quantity_limits_are_off_for_the_company_so_this: "Quantity limits are off for the company, so this has no effect until they are turned on (Settings → Orders and stock).",
  leave_empty_to_use_the_companys_limit_x_0_means: "Leave empty to use the company's limit (%s); 0 means no limit for this product.",
  leave_empty_to_use_the_companys_limit_0_means_no: "Leave empty to use the company's limit; 0 means no limit for this product.",
  inventory_management: "Inventory Management",
  availability_is_controlled_by_the_number_of_free: "Availability is controlled by the number of free license keys",
  stock_levels_for_physical_products: "Stock levels for physical products",
  refresh_from_database: "Refresh from database",
  stock_quantity: "Stock Quantity",
  not_tracked: "+ not tracked",
  edit_stock_in_options: "Edit stock in Options",
  the_sum_of_the_stock_of_x_variant_each_has_its_o: "The sum of the stock of %s variant: each has its own count, edited in Options.",
  the_sum_of_the_stock_of_x_variants_each_has_its: "The sum of the stock of %s variants: each has its own count, edited in Options.",
  no_variant_is_in_stock_the_product_cannot_be_pur: "No variant is in stock: the product cannot be purchased",
  leave_empty_for_unlimited_stock: "Leave empty for unlimited stock",
  refresh_stock_from_database: "Refresh stock from database",
  this_product_is_out_of_stock_and_cannot_be_purch: "This product is out of stock and cannot be purchased",
  upload_failed: "Upload failed",
  download_failed: "Download failed",
  could_not_copy_the_link: "Could not copy the link",
  delete_deliverable: "Delete deliverable",
  delete_x_x_the_file_is_removed_from_storage_and: "Delete \"%s\" (%s)? The file is removed from storage and customers who bought this product can no longer download it. This cannot be undone.",
  delete_x_the_file_is_removed_from_storage_and_cu: "Delete \"%s\"? The file is removed from storage and customers who bought this product can no longer download it. This cannot be undone.",
  delete_failed: "Delete failed",
  manage_downloadable_files_for_this_digital_produ: "Manage downloadable files for this digital product. Customers receive access after purchase.",
  add_deliverable: "Add Deliverable",
  name: "Name",
  e_g_e_book_pdf_source_files: "e.g. E-Book PDF, Source Files",
  choose_file: "Choose File",
  download_this_file: "Download this file",
  link_copied: "Link copied",
  copy_a_download_link_valid_5_minutes: "Copy a download link (valid 5 minutes)",
  disable_discount: "Disable discount",
  enable_discount: "Enable discount",
  from: "From",
  to: "To",
  presets: "Presets",
  add_discount: "Add Discount",
  discounts_apply_to_both_real_money_price_and_coi: "Discounts apply to both real-money price and coin price. When multiple discounts are active simultaneously, the one created most recently wins.",
  no_discounts_configured_add_one_manually_or_pick: "No discounts configured. Add one manually or pick a preset.",
  x_discounts_created_last_wins_when_multiple_are: "%s discounts — created last wins when multiple are active at the same time.",
  sun: "Sun",
  mon: "Mon",
  tue: "Tue",
  wed: "Wed",
  thu: "Thu",
  fri: "Fri",
  sat: "Sat",
  jan: "Jan",
  feb: "Feb",
  mar: "Mar",
  apr: "Apr",
  may: "May",
  jun: "Jun",
  jul: "Jul",
  aug: "Aug",
  sep: "Sep",
  oct: "Oct",
  nov: "Nov",
  dec: "Dec",
  every_friday: "Every Friday",
  every_weekend: "Every Weekend",
  christmas_holidays: "Christmas Holidays",
  easter: "Easter",
  summer: "Summer",
  winter: "Winter",
  black_friday: "Black Friday",
  new_years: "New Year's",
  valentines_day: "Valentine's Day",
  halloween: "Halloween",
  every_december: "Every December",
  back_to_school: "Back to School",
  spring_sale: "Spring Sale",
  every_monday: "Every Monday",
  every_sunday: "Every Sunday",
  always_indefinite: "Always (indefinite)",
  date_range: "Date range",
  days_of_the_week: "Days of the week",
  every_year_specific_month: "Every year — specific month",
  every_year_date_range: "Every year — date range",
  disabled: "Disabled",
  always_active: "Always Active",
  recurring: "Recurring",
  scheduled: "Scheduled",
  expired: "Expired",
  active: "Active",
  ch_s: " · ch. %s",
  s_page_s_s: "%s - Page %s / %s",
  s_the_same_in_every_language: "%s: the same in every language",
  audio_s: "Audio (%s)",
  background_s_s: "Background (%s, %s)",
  description_s: "Description [%s]",
  fill_the_empty_s_texts_from_s: "Fill the empty %s texts from %s",
  image_uploaded_s: "Image uploaded (%s)",
  audio_uploaded_s: "Audio uploaded (%s)",
  instructions_s: "Instructions [%s]",
  music_s: "Music (%s)",
  no_s_in_s: "No %s in %s",
  no_audio_for_s: "No audio for %s",
  price_must_be_at_least_s_s_to_meet_payment_proce: "Price must be at least %s %s to meet payment processor requirements.",
  sfx_s: "SFX (%s)",
  start_at_s_s: "Start at (s, %s)",
  text_s: "Text (%s)",
  the_details_the_product_page_lists_in_s_the_labe: "The details the product page lists, in %s. The labelled ones come from the content type; add any other with a key of your own.",
  the_details_the_product_page_lists_in_s_the_ones: "The details the product page lists, in %s. The ones come from the content type; add any other with a key of your own.",
  title_s: "Title (%s)",
  remove_s: "remove %s",
  delete_page_s: "Delete page %s",
  delete_track_s: "Delete track %s",
  s_pages: "%s pages",
  s_tracks: "%s tracks",
  page_s: "Page %s",
  track_s: "Track %s",
  translated_s_field_to_s: "Translated %s field to %s",
  translated_s_fields_to_s: "Translated %s fields to %s",
  zero_not_a_chapter_start: "0 = not a chapter start",
  add_platform: "Add Platform",
  add_field: "Add field",
  add_page: "Add page",
  add_track: "Add track",
  add_trigger_area: "Add trigger area",
  alignment: "Alignment",
  animation_s: "Animation (s)",
  auto_translate: "Auto-translate",
  box_height: "Box height",
  box_left: "Box left",
  box_top: "Box top",
  box_width: "Box width",
  chapter_index: "Chapter index",
  chapter_name_when_the_chapter_index_is_set: "Chapter name when the chapter index is set",
  clear: "Clear",
  close: "Close",
  color: "Color",
  could_not_create_the_page: "Could not create the page",
  could_not_create_the_trigger_area: "Could not create the trigger area",
  delete_page: "Delete page",
  delete_track: "Delete track",
  drag_to_reorder: "Drag to reorder",
  duration_s_1_audio: "Duration (s, -1 = audio)",
  edit: "Edit",
  end_angle: "End angle",
  end_offset_x: "End offset x",
  end_offset_y: "End offset y",
  end_scale: "End scale",
  font_size: "Font size",
  font: "Font",
  frame: "Frame",
  go_to_page_0_none: "Go to page (0 = none)",
  html_code: "HTML Code",
  html_snippet_editor: "HTML Snippet Editor",
  leave_this_field_out: "Leave this field out",
  library: "Library",
  loading: "Loading…",
  loop: "Loop",
  microphone_access_is_not_available: "Microphone access is not available",
  music: "Music",
  next_page: "Next page",
  no_audio_files_in_the_media_library_upload_one_f: "No audio files in the media library — upload one first",
  no_creators_match: "No creators match",
  no_image_files_in_the_media_library_upload_one_f: "No image files in the media library — upload one first",
  no_pages_yet_add_the_first_one: "No pages yet — add the first one.",
  no_platforms_added_to_this_product_yet: "No platforms added to this product yet.",
  no_platforms_defined_yet_add_platforms_in_s_from: "No platforms defined yet. Add platforms in %s from the catalog first.",
  no_text_on_this_page: "No text on this page",
  no_tracks_yet_add_the_first_one: "No tracks yet — add the first one.",
  nothing_to_translate: "Nothing to translate",
  open_this_product_s_page_in_the_store: "Open this product's page in the store",
  pick_a_series: "Pick a series",
  pick_an_audio_file: "Pick an audio file",
  pick_an_image: "Pick an image",
  preview: "Preview",
  previous_page: "Previous page",
  products_with_shipping_must_have_a_weight_greate: "Products with shipping must have a weight greater than 0 before publishing, or enable free shipping.",
  record: "Record",
  recording: "Recording…",
  remove_this_page_from_the_book_its_texts_and_med: "Remove this page from the book? Its texts and media references are dropped on save.",
  remove_this_track_from_the_book_its_texts_and_me: "Remove this track from the book? Its texts and media references are dropped on save.",
  reveal: "Reveal",
  save_failed: "Save failed",
  save: "Save",
  search_the_media_library: "Search the media library",
  select_platforms_where_this_product_is_available: "Select platforms where this product is available. Each entry has a product-specific download link.",
  select_platform: "Select platform…",
  sound_effect: "Sound effect",
  start_angle: "Start angle",
  start_offset_x: "Start offset x",
  start_offset_y: "Start offset y",
  start_scale: "Start scale",
  start_typing_a_name: "Start typing a name",
  stop: "Stop",
  store_link_https_apps_apple_com_app: "Store Link — https://apps.apple.com/app/...",
  switch_to_a_language_other_than_the_default_one: "Switch to a language other than the default one",
  take: "Take",
  tap_areas_on_the_page_that_play_a_sound_or_jump: "Tap areas on the page that play a sound or jump to another page.",
  this_product_has_no_catalog_document_yet: "This product has no catalog document yet.",
  this_product_type_does_not_use_this_tab: "This product type does not use this tab.",
  track_name_in_the_music_player: "Track name in the music player",
  transition: "Transition",
  translating: "Translating…",
  trigger_areas: "Trigger areas",
  upload: "Upload",
  pickup_from_the_shop: "Pickup from the shop",
  // a merchant has no Restore of their own: Aldoo brings a deleted product back
  delete_s_it_leaves_the_store_and_the_listings_at_once_write: "Delete %s? It leaves the store and the listings at once. Aldoo can bring it back within 30 days: write to us.",
  it_leaves_the_store_at_once_aldoo_can_bring_it_back: "It leaves the store at once. Aldoo can bring it back within 30 days: write to us.",
  uploading: "Uploading…",
  use_previous_page_s_music: "Use previous page's music",
  use_previous_page_s_sfx: "Use previous page's sfx",
  use_recording: "Use recording",
  vertical_focus: "Vertical focus",
  view_in_store: "View in store",
  all_languages: "all languages",
  default: "default",
  key: "key",
  value: "value",
  none_2: "— none —",
  draft: "Draft",
  in_review: "In Review",
  web: "web",
  phone_2: "phone",
  tablet: "tablet",
  instant: "Instant",
  fade: "Fade",
  slide: "Slide",
  zoom: "Zoom",
  comics: "comics",
  none_2_2: "none",
  box: "box",
  rounded: "rounded",
  left: "Left",
  center: "Center",
  right: "Right",
  typewriter: "Typewriter",
  left_2: "left",
  top: "top",
  width: "width",
  height: "height",
  author_2: "author",
  illustrator_2: "illustrator",
  narrator_2: "narrator",
  translator_2: "translator",
  nothing_set: "nothing set",
  pick_from_the_media_library: "Pick from the media library",
  upload_a_file: "Upload a file",
  read_it_aloud_and_record: "Read it aloud and record",
  give_these_to_every_scene: "Give these to every scene",
  template: "Template",
  apply_to_every_other_scene: "Apply to every other scene:",
  apply_to_all: "Apply to all",
  no_scene_selected: "No scene selected.",
  untitled_scene: "Untitled scene",
  which_chapter_this_scene_belongs_to: "Which chapter this scene belongs to",
  transition_in: "Transition in",
  how_this_scene_arrives_player_state_lua_pagetran: "How this scene arrives (player_state.lua pageTransitions)",
  order: "Order",
  move_up: "Move up",
  move_down: "Move down",
  copy_this_scene: "Copy this scene",
  duplicate: "Duplicate",
  delete_this_scene: "Delete this scene",
  picture: "Picture",
  keyframes: "Keyframes",
  x: "x",
  y: "y",
  scale: "scale",
  angle: "angle",
  start_keyframe_onto_the_end_one: "Start keyframe onto the end one",
  start_end: "start → end",
  end_keyframe_onto_the_start_one: "End keyframe onto the start one",
  end_start: "end → start",
  continue_from_where_the_previous_scene_ended: "Continue from where the previous scene ended",
  from_previous: "from previous",
  end_where_the_next_scene_starts: "End where the next scene starts",
  from_next: "from next",
  movement: "Movement",
  length_of_the_move_seconds: "Length of the move (seconds)",
  zero_leaves_the_picture_still: "0 leaves the picture still",
  where_a_taller_screen_crops_to_empty_means_the_m: "Where a taller screen crops to. Empty means the middle.",
  clear_2: "clear",
  words: "Words",
  what_is_on_screen: "What is on screen",
  voice_over: "Voice-over",
  look: "Look",
  the_book_s_font: "the book's font",
  colour: "Colour",
  comic_frame_behind_the_words: "Comic frame behind the words",
  timing: "Timing",
  starts_at_s: "Starts at (s)",
  after_the_scene_begins: "After the scene begins",
  shown_for_s: "Shown for (s)",
  zero_means_to_the_end_of_the_scene: "0 means to the end of the scene",
  style_from_previous: "style from previous",
  style_from_next: "style from next",
  effect: "Effect",
  loop_until_the_scene_ends: "Loop until the scene ends",
  keep_the_previous_scene_s_effect_playing: "Keep the previous scene's effect playing",
  track: "Track",
  keep_the_previous_scene_s_music_playing: "Keep the previous scene's music playing",
  add_a_tap_area: "Add a tap area",
  add: "Add",
  delete_this_tap_area: "Delete this tap area",
  this_scene_has_no_tap_areas: "This scene has no tap areas.",
  sound_when_tapped: "Sound when tapped",
  go_to_scene: "Go to scene",
  empty_for_none_scene_numbers_start_at_1: "Empty for none. Scene numbers start at 1.",
  scene_s_of_s: "Scene %s of %s",
  image_s: "Image (%s)",
  edit_the_s_keyframe: "Edit the %s keyframe",
  fast_s_s: "fast (%ss)",
  slow_s_s: "slow (%ss)",
  render_box_s: "Render box (%s)",
  tap_areas_s: "Tap areas %s",
  nothing_to_put_that_on_select_a_scene_part_first: "Nothing to put that on — select a scene part first",
  select_what_the_file_is_for_first: "Select what the file is for first",
  that_sound_could_not_be_played: "That sound could not be played",
  delete_media_file: "Delete media file",
  deleted: "Deleted",
  remove_this_scene_from_the_book_its_texts_and_me: "Remove this scene from the book? Its texts and media stay in the library.",
  drag_to_move_when_it_appears_drag_the_edge_for_h: "Drag to move when it appears, drag the edge for how long it stays",
  music_2: "music",
  music_looping_until_the_scene_ends: "Music, looping until the scene ends",
  music_under_this_scene: "Music under this scene",
  sound_effect_looping_until_the_scene_ends: "Sound effect, looping until the scene ends",
  sound_effect_once: "Sound effect, once",
  tap_area: "Tap area",
  tools: "Tools",
  undo_z: "Undo (⌘Z)",
  redo_z: "Redo (⇧⌘Z)",
  add_a_scene_after_this_one: "Add a scene after this one",
  scene: "Scene",
  duplicate_this_scene: "Duplicate this scene",
  language: "Language",
  the_only_language_this_book_is_written_in: "The only language this book is written in",
  the_language_being_edited: "The language being edited",
  handles: "Handles",
  book_settings: "Book settings",
  inspector: "Inspector",
  add_a_scene: "Add a scene",
  images_2: "images",
  sounds: "sounds",
  search_the_library: "Search the library",
  show_files_the_book_already_uses: "Show files the book already uses",
  upload_a_picture: "Upload a picture",
  upload_a_sound: "Upload a sound",
  delete_from_the_library: "Delete from the library",
  listen: "Listen",
  nothing_here: "Nothing here.",
  previous_scene: "Previous scene",
  play: "Play",
  pause: "Pause",
  next_scene: "Next scene",
  timeline_zoom: "Timeline zoom",
  drag_to_change_how_long_it_lasts: "Drag to change how long it lasts",
  picture_set_on_scene_s: "Picture set on scene %s",
  sound_set_on_scene_s: "Sound set on scene %s",
  delete_s_scenes_using_it_will_show_nothing: "Delete %s? Scenes using it will show nothing.",
  delete_scene_s: "Delete scene %s",
  scene_s: "Scene %s",
  picture_moves_for_s_s_in_on_s_drag_the_edge_to_c: "Picture moves for %ss, in on %s · drag the edge to change the length",
  scene_s_start_keyframe: "Scene %s · start keyframe",
  scene_s_end_keyframe: "Scene %s · end keyframe",
  voice_over_s_drag_to_move_when_it_starts: "Voice-over · %s · drag to move when it starts",
  music_s_2: "music %s",
  sfx_s_2: "sfx ⟳ %s",
  sfx_s_2_2: "sfx %s",
  tap_s_s: "tap %s → %s",
  tap_s: "tap %s ♪",
  tap_s_2: "tap %s",
  tap_area_jumps_to_scene_s: "Tap area, jumps to scene %s",
  s_scenes: "%s scenes",
  s_of_s_click_to_put_it_on_the_selection_drag_a_p: "%s of %s · click to put it on the selection, drag a picture onto a scene",
  scene_s_s: "Scene %s · %s",
  s_keyframe: "%s keyframe",
  s_scene_s_s: "%s — scene %s / %s",
  background_colour: "Background colour",
  what_shows_behind_a_picture_that_does_not_fill_t: "What shows behind a picture that does not fill the screen",
  content_type_3: "Content type",
  default_font: "Default font",
  used_by_any_scene_that_names_no_font_of_its_own: "Used by any scene that names no font of its own",
  e_g_nunito: "e.g. Nunito",
  divided_into_chapters: "Divided into chapters",
  done: "Done",
  drag_to_draw_a_tap_area: "Drag to draw a tap area",
  fit_the_picture_to_every_layout: "Fit the picture to every layout",
  fit: "fit",
  drag_the_text_box: "Drag the text box",
  resize_the_text_box: "Resize the text box",
  sound: "sound",
  drag_the_tap_area: "Drag the tap area",
  resize_the_tap_area: "Resize the tap area",
  drag_to_move_the_s_keyframe_wheel_to_scale_shift: "Drag to move the %s keyframe · wheel to scale · Shift locks an axis · Alt scales faster",
  scene_s_2: "→ scene %s",
  pick_a_pdf_first: "Pick a PDF first",
  pipelines: "Pipelines",
  running: "Running…",
  open_the_editor: "Open the editor",
  scenes_keyframes_and_the_timeline_the_size_of_th: "Scenes, keyframes and the timeline, the size of the screen.",
  what_this_s_is_made_of_everything_is_edited_in_t: "What this %s is made of. Everything is edited in the editor.",
  s_img_s_audio: "%s img · %s audio",
  scenes: "Scenes",
  text: "Text",
  voice: "Voice",
  sound_fx: "Sound FX",
  tap_areas: "Tap areas",
  pick_things_on_the_picture_drag_the_picture_itse: "Pick things on the picture, drag the picture itself (V)",
  place_and_size_the_words_t: "Place and size the words (T)",
  put_a_picture_on_this_scene_i: "Put a picture on this scene (I)",
  music_effect_and_voice_over_a: "Music, effect and voice-over (A)",
  draw_an_area_that_answers_a_tap_r: "Draw an area that answers a tap (R)",
  remove_what_is_selected_backspace: "Remove what is selected (Backspace)",
  pdf_bookscript_pages_texts_images: "PDF → bookscript (pages, texts, images)",
  pdf_extract_embedded_images_to_the_media_library: "PDF → extract embedded images to the media library",
  aldoo_book: "Aldoo Book",
  music_album: "Music Album",
  audio_book: "Audio Book",
  fadein: "FadeIn",
  start: "start",
  end: "end",
  scenes_2: "scenes",
  media: "media",
  music_album_2: "music album",
  audio_book_2: "audio book",
  book: "book",
  start_keyframe: "Start keyframe",
  end_keyframe: "End keyframe",
  move_length: "Move length",
  render_box: "Render box",
  runtime: "Runtime",
  narrated: "Narrated",
  with_music: "With music",
  media_files: "Media files",
  sound_2: "Sound",
  signed_payout_contract: "Signed payout contract",
  add_n_as_a_new_name: "Add “%s” as a new name",
  adding: "Adding…",
  enter_a_name_in_letters_only: "Enter a name in letters only",
  the_name_could_not_be_added: "The name could not be added",
  add_n_as_a_new_series: "Add “%s” as a new series",
  enter_a_series_name_with_letters: "Enter a series name with letters",
  the_series_could_not_be_added: "The series could not be added",
  vendor_price: "Price",
  vendor_currency: "Currency",
  vendor_price_what_a_buyer_pays: "What a buyer pays for the product, once.",
  vendor_price_type_note: "This product is set up to be sold another way (a bundle or a subscription). Once you save, it is sold as a one-time purchase.",
  vendor_price_required: "Enter a price greater than 0.",
  vendor_price_invalid: "Write the price as a number with up to two decimals, e.g. 12.99.",
  vendor_price_current: "Current price",
  vendor_price_one_time_purchase: "one-time purchase",
  vendor_price_none: "No price yet: the product cannot be sold until it has one.",
  store_page_follows_type: "Follows the %s defaults: a change of the product's content type or of its defaults shows here.",
  store_page_own_selection: "This product's own selection: a change of its content type leaves it as it is.",
  // the Shipping tab's delivery methods (DeliveryMethods)
  delivery_methods: "Delivery methods",
  delivery_methods_hint: "The ways a buyer can receive this product. Checkout offers a parcel only the ways every product in it allows.",
  change_the_companys_delivery_settings: "Change the company's delivery settings",
  same_as_the_company: "Same as the company",
  every_delivery_method_the_company_ships_with: "Every delivery method the company ships with.",
  only_the_methods_chosen_here_among_the_companys: "Only the methods chosen here, among the company's.",
  company_has_no_delivery_method_on: "The company has no delivery method on: physical products cannot be delivered.",
  choose_at_least_one_delivery_method: "Choose at least one delivery method for this product.",
  speedy_to_your_address: "Speedy to your address",
  the_courier_brings_it_to_the_buyers_door: "The courier brings it to the buyer's door",
  speedy_office: "Speedy office",
  the_buyer_collects_it_at_a_speedy_office: "The buyer collects it at a Speedy office",
  speedy_locker: "Speedy locker",
  the_buyer_collects_it_from_a_speedy_automat_with: "The buyer collects it from a Speedy automat with a code",
  boxnow_locker: "BOX NOW locker",
  the_buyer_collects_it_from_a_box_now_locker_wit: "The buyer collects it from a BOX NOW locker with a code",
  price_to_the_buyer_eur: "Price to the buyer (EUR)",
  what_a_buyer_pays_for_one_parcel_to_a_box_now_l: "What a buyer pays for one parcel to a BOX NOW locker. Empty: the platform's price list.",
  price_to_the_buyer_eur_an_amount_above_zero_e_g: "Price to the buyer (EUR): an amount above zero, e.g. 3.20",
  econt_to_your_address: "Econt to your address",
  econt_office: "Econt office",
  the_buyer_collects_it_at_an_econt_office: "The buyer collects it at an Econt office",
  econtomat: "Econtomat",
  the_buyer_collects_it_from_an_econtomat_with_a_c: "The buyer collects it from an Econtomat with a code",
  pigeon_express_to_your_address: "Pigeon Express to your address",
  pigeon_express_office: "Pigeon Express office",
  the_buyer_collects_it_at_a_pigeon_express_office: "The buyer collects it at a Pigeon Express office",
  pigeon_express_locker: "Pigeon Express locker",
  the_buyer_collects_it_from_a_pigeon_express_aps: "The buyer collects it from a Pigeon Express APS locker",
  documents: "Documents",
  tags: "Tags",
  a_document_may_be_at_most_n_mb: "A document may be at most %s MB",
  datasheets_specifications_and_manuals_the_produc: "Datasheets, specifications and manuals. The product page lists them in its Specifications tab; a PDF opens in the site's viewer.",
  remove_the_document: "Remove the document",
  imported: "Imported",
  add_a_document: "Add a document",
  pdf_office_or_text_file_up_to_n_mb: "PDF, office or text file, up to %s MB",
  price_to_an_office_or_econtomat_eur: "Price to an office or Econtomat (EUR)",
  what_a_buyer_pays_for_one_parcel_to_an_econt_of: "What a buyer pays for one parcel to an Econt office or Econtomat. Empty: the platform's price list.",
  price_to_an_address_eur: "Price to an address (EUR)",
  what_a_buyer_pays_for_one_parcel_to_their_addre: "What a buyer pays for one parcel to their address. Empty: the platform's price list.",
  price_to_an_office_or_econtomat_eur_an_amount_a: "Price to an office or Econtomat (EUR): an amount above zero, e.g. 3.20",
  price_to_an_address_eur_an_amount_above_zero_e: "Price to an address (EUR): an amount above zero, e.g. 3.20",
  up_to_x_kg_per_parcel: "Up to %s kg per parcel",
  custom_selection: "Custom selection",
  the_language_the_products_texts_are_edited_in: "The language the product's texts and pictures are edited in",
  field_pages: "Pages",
  field_year: "Year",
  field_cover_type: "Cover Type",
  field_isbn: "ISBN",
  field_publisher: "Publisher",
  field_series: "Series",
  ui_save_these_changes: "Save these changes?",
  ui_filter_n_changes: "Filter %s changes",
  ui_no_change_was_found_saving_writes_the_record: "No change was found. Saving writes the record as it is.",
  ui_field: "Field",
  ui_before: "Before",
  ui_after: "After",
  ui_take_this_change_back: "Take this change back",
  ui_revert_shown_n: "Revert shown (%s)",
  ui_revert_all: "Revert all",
  ui_saving: "Saving…",
  ui_n_changes: "%s changes",
  ui_added: "added",
  ui_removed: "removed",
  ui_present: "present",
  ui_author_display_name: "Author display name",
  ui_age_rating: "Age rating",
  ui_presentation_order: "Presentation order",
  ui_free_shipping: "Free shipping",
  ui_publish_status: "Publish status",
  ui_shipping_methods: "Shipping methods",
  ui_stock: "Stock",
  ui_type: "Type",
  rv_waiting_for_review: "Waiting for review",
  rv_cancel_review: "Cancel Review",
  rv_cancelling: "Cancelling…",
  rv_cancel_review_q: "Cancel the review?",
  rv_cancel_review_message: "%s leaves the review queue and goes back to drafts. You can send it for review again when it is ready.",
  rv_keep_in_review: "Keep in review",
  book_preview: "Book Preview",
  a_pdf_with_sample_pages_of_the_book: "A PDF with sample pages of the book. Buyers open it with \"Look inside\" on the product page, where it turns like a book.",
  the_preview_must_be_a_pdf_file: "The preview must be a PDF file",
  the_preview_may_be_at_most_s_mb: "The preview may be at most %s MB",
  remove_the_book_preview: "Remove the book preview",
  the_store_page_no_longer_offers_look_inside: "The store page no longer offers \"Look inside\" for this book.",
  replace_the_file: "Replace the file",
  upload_a_pdf: "Upload a PDF",
  pdf_up_to_s_mb: "PDF, up to %s MB",
  sample_pages_pdf: "Sample pages (PDF)",
  shown_with_look_inside_on_the_product_page: "Shown with \"Look inside\" on the product page",
  // the Video tab (the product's videos, one the main one: its trailer)
  video: "Video",
  youtube_videos_of_the_product_shown_in_its_gallery: "YouTube videos of the product, shown in its gallery in this order. The main one is its trailer.",
  enter_a_youtube_link: "Enter a YouTube link",
  this_video_is_in_the_list_already: "This video is in the list already",
  n_videos_at_most: "%s videos at most",
  main_video: "Main video",
  make_it_the_main_video: "Make it the main video",
  the_trailer: "The trailer",
  no_videos_yet: "No videos yet",
}
